import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Button,
  Collapse,
  Divider,
  Stack
} from '@mui/material';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isLoginPage = location.pathname === '/login';
  const isSignupPage = location.pathname === '/signup';

  const handleNavigate = (path: string) => {
    setMobileOpen(false);
    navigate(path);
  };

  return (
    <AppBar
      position="absolute"
      elevation={0}
      sx={{
        background: 'rgba(255, 255, 255, 0.92)',
        borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
        color: '#0A0B0D',
        backdropFilter: 'blur(16px)',
        boxShadow: 'none'
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 60 }, py: { xs: 1, md: 1 } }}>
          <Box
            component="a"
            href="/"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              textDecoration: 'none'
            }}
          >
            <img
              src="/tenantterms_wordmark_dark.svg"
              alt="TenantTerms"
              style={{ height: 48 }}
              onError={(event) => {
                (event.currentTarget as HTMLImageElement).src = '/tenantterms_black_transparent.png';
              }}
            />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Stack
            direction="row"
            spacing={1.5}
            sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}
          >
            {!isLoginPage && (
              <Button
                variant="text"
                onClick={() => handleNavigate('/login')}
                sx={{
                  color: '#0A0B0D',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.95rem'
                }}
              >
                Log in
              </Button>
            )}
            {!isSignupPage && (
              <Button
                variant="contained"
                onClick={() => handleNavigate('/signup')}
                sx={{
                  background: '#0052FF',
                  color: '#FFFFFF',
                  borderRadius: '40px',
                  px: 3,
                  py: 1.25,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  '&:hover': {
                    background: '#0041CC'
                  }
                }}
              >
                Sign up
              </Button>
            )}
          </Stack>

          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <button
              type="button"
              aria-label={mobileOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={mobileOpen}
              onClick={() => setMobileOpen((previous) => !previous)}
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                border: '1px solid rgba(15, 23, 42, 0.12)',
                background: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                flexDirection: 'column',
                gap: mobileOpen ? 0 : 5
              }}
            >
              <span
                style={{
                  width: 18,
                  height: 2,
                  background: '#0A0B0D',
                  borderRadius: 1,
                  transform: mobileOpen ? 'translateY(5px) rotate(45deg)' : 'none',
                  transition: 'transform 0.2s ease'
                }}
              />
              <span
                style={{
                  width: 18,
                  height: 2,
                  background: '#0A0B0D',
                  borderRadius: 1,
                  opacity: mobileOpen ? 0 : 1,
                  transition: 'opacity 0.2s ease'
                }}
              />
              <span
                style={{
                  width: 18,
                  height: 2,
                  background: '#0A0B0D',
                  borderRadius: 1,
                  transform: mobileOpen ? 'translateY(-5px) rotate(-45deg)' : 'none',
                  transition: 'transform 0.2s ease'
                }}
              />
            </button>
          </Box>
        </Toolbar>

        <Collapse in={mobileOpen} timeout="auto" unmountOnExit sx={{ display: { xs: 'block', md: 'none' } }}>
          <Box sx={{ pb: 2 }}>
            <Divider sx={{ borderColor: 'rgba(15, 23, 42, 0.08)' }} />
            <Stack spacing={1.5} sx={{ mt: 2 }}>
              {!isSignupPage && (
                <Button
                  fullWidth
                  onClick={() => handleNavigate('/signup')}
                  sx={{
                    height: 48,
                    borderRadius: '40px',
                    background: '#0052FF',
                    color: '#FFFFFF',
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '1rem',
                    '&:hover': {
                      background: '#0041CC'
                    }
                  }}
                >
                  Sign up
                </Button>
              )}
              {!isLoginPage && (
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => handleNavigate('/login')}
                  sx={{
                    height: 48,
                    borderRadius: '40px',
                    borderColor: 'rgba(15, 23, 42, 0.2)',
                    color: '#0A0B0D',
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '1rem'
                  }}
                >
                  Log in
                </Button>
              )}
            </Stack>
          </Box>
        </Collapse>
      </Container>
    </AppBar>
  );
};

export default Header; 
